module.exports = __webpack_public_path__ + "img/pubilc_code.3a0f2c82.png";